
import { Vue, Component, Ref } from 'vue-property-decorator';
import WithdrawService from '@/services/withdraw.service';
import lazyInject from '@/di';
import { FormModel } from 'ant-design-vue';


@Component
export default class ClickRejectionModal extends Vue {
  @lazyInject(WithdrawService)
  protected withdrawService!: WithdrawService;

  @Ref('formRef')
  formRef!: FormModel;

  visible = false;

  form = {
    reason: '提现账号不存在或姓名有误，建议核实账号和姓名是否准确',
    max_id: '',
    min_id: '',
    num: 0,
  };
  reason = '提现账号不存在或姓名有误，建议核实账号和姓名是否准确';

  rules = {
    reason: [{ required: true, message: '请输入驳回原因' }],
  };

  count = 0;

  async init() {
    const res = await this.withdrawService.accountErrorWithdrawal({});
    // console.log(this.reason, ' res');

    if (res.num > 0) {
      this.count = res.num;
      this.form.reason = this.reason;
      this.visible = true;
      this.form.max_id = res.max_id;
      this.form.min_id = res.min_id;
      this.form.num = res.num;
    } else {
      this.$message.warning('没有需要驳回的申请记录');
    }
  }
  handleOk() {
    this.visible = false;
  }
  async submitData() {
    this.formRef.validate(async (valid) => {
      if (valid) {
        // console.log(this.form, ' form');
        const res = await this.withdrawService.postRejectWithdrawal(this.form);
        if (res) {
          this.$message.success('操作成功');
          this.visible = false;
          this.$emit('refresh');
        }
      }
    });
  }

  handleCancel() {
    this.visible = false;
  }
}
